'use client';

import { useCompetitionContext } from "../providers/CompetitionContext";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"

import moment from 'moment';
import 'moment/locale/fr';
moment.locale('fr');

import { getCompetitionCopy } from "../lib/competitionCopy";

interface Race {
  id: number;
  feedUrl: string;
  date: string;
  type: string;
}

export function Calendar() {
  const { competitionData, competitionConfig } = useCompetitionContext();
  const copy = getCompetitionCopy(competitionConfig?.competitionFeed);

  // Example label function
  const getTypeLabel = (type: string) => {
    switch (type) {
      case "wt":
        return "WT"
      case "nwt":
        return "NWT"
      case "monument":
        return "MON"
      default:
        return type.toUpperCase()
    }
  }

  return (
    <div className="border overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-16">#</TableHead>
            <TableHead>{copy.raceLabelTitle}</TableHead>
            {/* <TableHead className="w-24">Type</TableHead> */}
            <TableHead className="w-32">Départ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {competitionData?.matches?.map((race: Race, index: number) => (
            <TableRow 
              key={race.id} 
              className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
            >
              <TableCell className="font-medium pt-0 pb-0">{index + 1}</TableCell>
              <TableCell className=" pt-0 pb-0">{race.feedUrl}</TableCell>
              {/* <TableCell className="font-medium pt-0 pb-0">{getTypeLabel(race.type)}</TableCell> */}
              <TableCell className="pt-2 pb-2 w-60">
                {moment.utc(race.date, "YYYY-MM-DD HH:mm:ss").local().format('dd DD/MM [à] HH.mm')}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
